/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAnalyticsPlay = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 2h20v13.101l-2-1.2V4H4v11h9v7H7v-2h4v-3H2z" />
        <path d="M18 11h-2.836L14 10.3l-1.027-1.54-2.344 3.282L8.586 10H6V8h3.414l.958.958 2.656-3.718L15.535 9H18zm4.944 7L15 13.234v9.532zm-3.888 0L17 19.234v-2.468z" />
      </g>
    </g>
  </Icon>
);
export { SvgAnalyticsPlay as AnalyticsPlay };
